export const vehicleStrings = {
  routeType: 'Вид ТС',
  agency: 'Предприятие',
  depotNumber: 'Гаражный номер',
  gosNomer: 'ГРЗ',
  route: 'Маршрут',
  driver: 'Водитель',
};

export const routeStrings = {
  short_name: 'Маршрут',
  name: 'Наименование',
  stops: 'Остановки',
};

export const stopStrings = {
  name: 'Наименование',
  routes: 'Маршруты',
};

export const agencyStrings = {
  title: 'Наименование',
  address: 'Адрес',
  phone: 'Телефон',
};

export const bcRegions = {
  closed_tasks: 'Количество закрытых нарядов',
  td_adress: 'Адрес',
  td_id: 'Идентификатор',
  td_name: 'Территориальный отдел',
  workers_all: 'Общее число сотрудников',
  workers_at_work: 'Количество сотрудников в наряде',
};
